'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = (0, _immutable.Record)({
  messagesUtk: null,
  hubspotUtk: null,
  isFirstVisitorSession: true
}, 'VisitorIdentity');
module.exports = exports['default'];